import PageLang from "./page-lang";

class Translations {
  constructor() {
    this.lang = PageLang.get();
    this.translations = {
      _0: {
        pl: "Niedziela",
        en: "Sunday"
      },
      _1: {
        pl: "Poniedziałek",
        en: "Monday"
      },
      _2: {
        pl: "Wtorek",
        en: "Tuesday"
      },
      _3: {
        pl: "Środa",
        en: "Wednesday"
      },
      _4: {
        pl: "Czwartek",
        en: "Thursday"
      },
      _5: {
        pl: "Piątek",
        en: "Friday"
      },
      _6: {
        pl: "Sobota",
        en: "Saturday"
      },
      _wycieczki: {
        pl: "Wycieczki",
        en: "Tours"
      },
      _ilosc: {
        pl: "Ilość",
        en: "Quantity"
      },
      _cena: {
        pl: "Cena",
        en: "Price"
      },
      _suma: {
        pl: "Suma",
        en: "Sum"
      },
      _bilety: {
        pl: "Bilety",
        en: "Tickets"
      },
      _produkty: {
        pl: "Produkty",
        en: "Products"
      },
      _liczba: {
        pl: "Liczba",
        en: "Quantity"
      },
      _63239ba01c76fbdc81999eb5f3e19835: {
        pl: "Kup bilet",
        en: "Buy a ticket"
      },
      _123d6e65359db3d99e652b69e46628b9: {
        pl: "Brak dostępnych miejsc",
        en: "No places available"
      },
      _29a8ca34f34be8d3518d6117a232eb7b: {
        pl: "Dostępne bilety",
        en: "Available tickets"
      }
    };
  }

  get(word) {
    if (!word) {
      throw new Error("Funkcja wymaga parametru!");
    }

    return this.translations[word][this.lang];
  }
}
export default Translations;
